// E.164 phone primitives shared by the API's Zod schemas and the backoffice
// client validation. Keep in sync with the storefront's richer dial-code
// helpers in apps/web/src/lib/phone.ts (which stay app-local to avoid pulling
// UI concerns into this package).

/** Strict E.164: '+' then 8-15 digits (ITU max is 15). */
export const E164_RE = /^\+[1-9]\d{7,14}$/;

/** Strip the formatting characters people paste along with phone numbers
 *  (spaces, dots, dashes, parentheses) before E.164 validation. */
export function normalizeE164Input(value: string): string {
  return value.trim().replace(/[\s().-]/g, '');
}
